import React from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Input,
  Row,
  CardTitle,
  CardText,
  CardHeader,
} from "reactstrap";
import { useEffect, useState } from "react";
import moment from "moment";
import { addChequeBounceCharges, getAllExpAptions, getDayBookData, getExpenseData, saveBillerORcate, saveExpense } from "../../util/APIUtils";
import { LoadingOverlay } from "../../util/Helpers";
import ExpenseBody from "./ExpenseBody";
import AddBillerModel from "./AddBillerModel";
import AddExpenseScreen from "./AddExpenseScreen";
import { ButtonStyles } from "../../constants/ButtonStyles";

const getInitialExpenseDate = () => {
  const today = moment();

  if (today.date() >= 21) {
    // If on 21st or later: show from 21st current month to 20th next month
    const frmDate = today.clone().date(21).format("YYYY-MM-DD");
    return { frmDate, toDate: today.clone().add(1, "month").date(20).format("YYYY-MM-DD") };
  } else {
    // If before 21st: show from 21st previous month to 20th current month
    const frmDate = today.clone().subtract(1, "month").date(21).format("YYYY-MM-DD");
    return { frmDate, toDate: today.clone().date(20).format("YYYY-MM-DD") };
  }
};

const getCurrentDateISO = () => {
  return new Date().toISOString().substring(0, 10);
};

export default function Expense() {
  const initialDates = getInitialExpenseDate();
  const [values, setValues] = useState({
    frmDate: initialDates.frmDate,
    toDate: initialDates.toDate,
  });
  const [trans, setTrans] = useState({});
  const [block, setBlock] = useState(false);
  const [open, setOpen] = useState(false);
  const [contextMenuPosition, setContextMenuPosition] = useState({
    x: 0,
    y: 0,
  });
  const [currentRow, setCurrentRow] = useState({});
  const [modal, setModal] = useState(false);
  const [operation, setOperation] = useState("");
  const [expense, setExpense] = useState({
    "category": "0",
    "payeeName": "0",
    "paymentType": "0",
    "date": new Date().toISOString().substring(0, 10)
  });
  const [paymentTypes, setPaymntTypes] = useState([]);
  const [category, setCategory] = useState([]);
  const [payee, setPayee] = useState([]);
  const [error, setError] = useState('');
  const [types, setType] = useState({});

  // New state for screen-based navigation
  const [showAddExpenseScreen, setShowAddExpenseScreen] = useState(false);
  const [showAddCategory, setShowAddCategory] = useState(false);
  const [showAddPayee, setShowAddPayee] = useState(false);
  const [categoryValues, setCategoryValues] = useState({ name: "" });
  const [payeeValues, setPayeeValues] = useState({ name: "" });
  const [categoryError, setCategoryError] = useState("");
  const [payeeError, setPayeeError] = useState("");


  useEffect(() => {
    loadReqData();
    loadOptions();
  }, []);

  const toggle = () => {
    setOpen(!open);
  };
  const selectedOption = (option) => {
    if (option == 1) {
      addChequePenality();
    }
  };
  const addChequePenality = () => {
    setBlock(true);
    addChequeBounceCharges(values).then((response) => {
      swal({
        text: "Added Cheque Bounce charges succesfully",
      });
      setBlock(false);
    });
  };
  const handleRightClick = (e, row) => {
    //  e.preventDefault();
    setContextMenuPosition({ x: e.clientX, y: e.clientY });
    setOpen(true);
    setCurrentRow(row);
  };
  const loadReqData = () => {
    setBlock(true);
    getExpenseData(values).then((response) => {
      setTrans(response);
      setBlock(false);
    });
  };

  const loadOptions = () => {
    getAllExpAptions().then((response) => {
      setPaymntTypes(response.paymentTypes);
      setPayee(response.payees);
      setCategory(response.categories);
    });
  };

  const onChangeNotesMap = ({ target }) => {
    const { name, value } = target;
    setValues((previousState) => ({
      ...previousState,
      [name]: value,
    }));
  };

  const updateMap = (e) => {
    if (Object.keys(values).length !== 2) {
      return false;
    }
    setBlock(true);
    getExpenseData(values).then((response) => {
      setBlock(false);
      setTrans(response);
    });
  };
  const clearAll = (e) => {
    const initialDates = getInitialExpenseDate();
    setValues({
      frmDate: initialDates.frmDate,
      toDate: initialDates.toDate,
    });
  };

  const setAction = (ops) => {
    setOperation(ops);

    toggleModel();

  }

  const toggleModel = () => {
    setError("")
    setModal(!modal);
  }

  const onChangeModelForm = ({ target }) => {
    const { name, value } = target;
    setExpense((previousState) => ({
      ...previousState,
      [name]: value,
    }));
  };

  const onSubmitodelForm = () => {
    if (operation === 1) {
      if (!validateInsertBillModel(expense)) {
        return false;
      }
      setBlock(true);
      saveExpense(expense)
        .then((response) => {
          setBlock(false);
          loadReqData();
          cancel();
          swal({
            text: "Bill saved successfully",
          })
        })
        .catch((error) => {
          setBlock(false);
          cancel();
          swal({
            text: "Unexpected Error " + error,
          })
        });
    } else {
      {
        // save biller

        delete expense.category;
        delete expense.payeeName;
        delete expense.paymentType;
        expense.action = operation;
        if (!validatePayeeOrCateModel(expense)) {
          return false;
        }
        setBlock(true);
        saveBillerORcate(expense)
          .then((response) => {
            setBlock(false);
            cancel();
            loadOptions();
            swal({
              text: "Record saved successfully",
            })
          })
          .catch((error) => {
            cancel();
            setBlock(false);
            swal({
              text: "Unexpected Error " + error,
            })

          });
      }
    }
  }

  const validateInsertBillModel = (exp) => {
    const excludedKey = 'refNum';
    const count = Object.keys(exp).filter(key => key !== excludedKey).length;
    if (count !== 6 || exp.category === "0" || exp.payeeName === "0" || exp.paymentType === "0" || exp.amount.trim() === "") {
      setError("Please fill all the fields");
      return false;
    } else {
      return true;
    }

  }
  const validatePayeeOrCateModel = (exp) => {
    if (exp.action == 3) {
      if (exp.name === null || exp.name === undefined || exp.name.trim() === "") {
        setError("Please fill all the Category name");
        return false;
      } else {
        return true;
      }
    } else {
      if (exp.action == 2 && Object.keys(exp).length !== 5) {
        setError("Please fill all the fields");
        return false;

      } else {
        return true;
      }
    }
  }
  const cancel = () => {
    let obj = {
      "category": "0",
      "payeeName": "0",
      "paymentType": "0",
      "date": new Date().toISOString().substring(0, 10)
    };
    setExpense(obj);
    toggleModel();
  };

  // Screen navigation handlers
  const openAddExpenseScreen = () => {
    setError("");
    setShowAddExpenseScreen(true);
  };

  const closeAddExpenseScreen = () => {
    let obj = {
      "category": "0",
      "payeeName": "0",
      "paymentType": "0",
      "date": new Date().toISOString().substring(0, 10)
    };
    setExpense(obj);
    setError("");
    setShowAddCategory(false);
    setShowAddPayee(false);
    setCategoryValues({ name: "" });
    setPayeeValues({ name: "" });
    setCategoryError("");
    setPayeeError("");
    setShowAddExpenseScreen(false);
  };

  // Inline Category handlers
  const onAddCategory = () => {
    setShowAddCategory(!showAddCategory);
    setCategoryError("");
    setCategoryValues({ name: "" });
  };

  const onChangeCategoryForm = ({ target }) => {
    const { name, value } = target;
    setCategoryValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const onSaveCategory = () => {
    if (!categoryValues.name || categoryValues.name.trim() === "") {
      setCategoryError("Please enter category name");
      return;
    }
    setBlock(true);
    saveBillerORcate({ ...categoryValues, action: 3 })
      .then((response) => {
        setBlock(false);
        loadOptions();
        setShowAddCategory(false);
        setCategoryValues({ name: "" });
        setCategoryError("");
        swal({ text: "Category saved successfully" });
      })
      .catch((error) => {
        setBlock(false);
        swal({ text: "Unexpected Error " + error });
      });
  };

  const onCancelCategory = () => {
    setShowAddCategory(false);
    setCategoryValues({ name: "" });
    setCategoryError("");
  };

  // Inline Payee handlers
  const onAddPayee = () => {
    setShowAddPayee(!showAddPayee);
    setPayeeError("");
    setPayeeValues({ name: "" });
  };

  const onChangePayeeForm = ({ target }) => {
    const { name, value } = target;
    setPayeeValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const onSavePayee = () => {
    if (!payeeValues.name || payeeValues.name.trim() === "") {
      setPayeeError("Please enter payee name");
      return;
    }
    setBlock(true);
    saveBillerORcate({ ...payeeValues, action: 2 })
      .then((response) => {
        setBlock(false);
        loadOptions();
        setShowAddPayee(false);
        setPayeeValues({ name: "" });
        setPayeeError("");
        swal({ text: "Payee saved successfully" });
      })
      .catch((error) => {
        setBlock(false);
        swal({ text: "Unexpected Error " + error });
      });
  };

  const onCancelPayee = () => {
    setShowAddPayee(false);
    setPayeeValues({ name: "" });
    setPayeeError("");
  };

  // Save expense from screen
  const onSaveExpenseFromScreen = () => {
    if (!validateInsertBillModel(expense)) {
      return false;
    }
    setBlock(true);
    saveExpense(expense)
      .then((response) => {
        setBlock(false);
        loadReqData();
        // Reset form for next expense entry, stay on same screen
        let obj = {
          "category": "0",
          "payeeName": "0",
          "paymentType": "0",
          "date": new Date().toISOString().substring(0, 10)
        };
        setExpense(obj);
        setError("");
        swal({ text: "Bill saved successfully! You can add another expense." });
      })
      .catch((error) => {
        setBlock(false);
        swal({ text: "Unexpected Error " + error });
      });
  };

  return (
    <div>
      {block && <LoadingOverlay />}

      {/* Show Add Expense Screen */}
      {showAddExpenseScreen ? (
        <AddExpenseScreen
          onBack={closeAddExpenseScreen}
          onChangeModelForm={onChangeModelForm}
          onSubmitodelForm={onSaveExpenseFromScreen}
          expense={expense}
          paymentTypes={paymentTypes}
          category={category}
          payee={payee}
          error={error}
          onAddCategory={onAddCategory}
          onAddPayee={onAddPayee}
          showAddCategory={showAddCategory}
          showAddPayee={showAddPayee}
          categoryValues={categoryValues}
          payeeValues={payeeValues}
          onChangeCategoryForm={onChangeCategoryForm}
          onChangePayeeForm={onChangePayeeForm}
          onSaveCategory={onSaveCategory}
          onSavePayee={onSavePayee}
          onCancelCategory={onCancelCategory}
          onCancelPayee={onCancelPayee}
          categoryError={categoryError}
          payeeError={payeeError}
        />
      ) : (
        <div>
          <Card style={{
            borderRadius: "15px",
            boxShadow: "0 10px 40px rgba(0,0,0,0.1)",
            border: "none",
            overflow: "hidden"
          }}>
            <CardHeader style={{
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              padding: "20px 25px",
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              borderBottom: "none"
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <i className="fa fa-money" style={{ fontSize: "24px", color: "#fff" }}></i>
                <strong style={{ fontSize: '1.2rem', color: "#fff" }}>Expense</strong>
              </div>
              <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                <Button style={ButtonStyles.successSm} onClick={openAddExpenseScreen}>
                  <i className="fa fa-plus" style={{ marginRight: "5px" }} />Add Bill
                </Button>
                <Button style={ButtonStyles.warningSm} onClick={() => setAction(2)}>
                  <i className="fa fa-user-plus" style={{ marginRight: "5px" }} />Add Payee
                </Button>
                <Button style={ButtonStyles.primarySm} onClick={() => setAction(3)}>
                  <i className="fa fa-tag" style={{ marginRight: "5px" }} />Add Category
                </Button>
              </div>
            </CardHeader>
            <CardBody style={{ padding: "25px" }}>
              <Row className="mb-3" style={{ alignItems: "center" }}>
                <Col sm="3">
                  <Input
                    bsSize="sm"
                    type="date"
                    name="frmDate"
                    id="frmDate"
                    onChange={onChangeNotesMap}
                    value={values.frmDate}
                    style={{ borderRadius: "8px", border: "1px solid #e0e0e0", padding: "8px 12px" }}
                  />
                </Col>
                <Col sm="3">
                  <Input
                    bsSize="sm"
                    type="date"
                    name="toDate"
                    id="toDate"
                    onChange={onChangeNotesMap}
                    value={values.toDate}
                    style={{ borderRadius: "8px", border: "1px solid #e0e0e0", padding: "8px 12px" }}
                  />
                </Col>
                <Col sm="3">
                  <Button style={{ ...ButtonStyles.primarySm, marginRight: "10px" }} onClick={updateMap}>
                    <i className="fa fa-search" style={{ marginRight: "5px" }} />Go
                  </Button>
                  <Button style={ButtonStyles.secondarySm} onClick={clearAll}>
                    <i className="fa fa-times" style={{ marginRight: "5px" }} />Cancel
                  </Button>
                </Col>
                <Col sm="3" />
              </Row>
              <Row style={{ marginBottom: "25px" }}>
                <Col sm="4">
                  <Card style={{
                    background: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
                    borderRadius: "12px",
                    border: "none",
                    padding: "20px",
                    color: "#fff"
                  }}>
                    <div style={{ fontSize: "14px", opacity: "0.9" }}>Total Expense</div>
                    <div style={{ fontSize: "28px", fontWeight: "700" }}>{trans.totalExpenses || 0}</div>
                  </Card>
                </Col>
                <Col sm="4"></Col>
                <Col sm="4"></Col>
              </Row>
            </CardBody>
          </Card>
          <Card style={{
            borderRadius: "15px",
            boxShadow: "0 10px 40px rgba(0,0,0,0.1)",
            border: "none",
            overflow: "hidden",
            marginTop: "20px"
          }}>
            <CardBody style={{ padding: "25px" }}>
              <AddBillerModel
                OnToggle={toggleModel}
                view={modal && (operation === 2 || operation === 3)}
                onChangeModelForm={onChangeModelForm}
                onSubmitodelForm={onSubmitodelForm}
                cancel={cancel}
                values={expense}
                labelName={operation}
                error={error}
              />
              <ExpenseBody
                data={trans.expenses}
                open={open}
                toggle={toggle}
                selectedOption={selectedOption}
                handleRightClick={handleRightClick}
                contextMenuPosition={contextMenuPosition}
                currentRow={currentRow}
              />
            </CardBody>
          </Card>
        </div>
      )}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/CustomComponents/Expense.js